import { Link } from 'react-router-dom';

export function About() {
  return (
    <div className="page-narrow">
      <header className="pagehead">
        <img src="/logo.png" alt="" className="about-logo" />
        <h1>About ScrollWind</h1>
        <p className="lede">A reader built around your books, not the other way round.</p>
      </header>

      <div className="prose">
        <p>
          ScrollWind is a personal reading app for the books you already own. It opens your EPUBs and
          PDFs, keeps your place across every device, and reads to you in natural neural voices — all
          without getting between you and your files.
        </p>
        <h2>Local-first, yours to keep</h2>
        <p>
          Your books live where you put them — on your phone, or in a folder on your PC that ScrollWind
          reads from directly. We sync only the small things that make reading seamless: your library
          list and your place in each book. The files themselves are never uploaded to us; transfers
          between your own devices go over a private, encrypted relay.
        </p>
        <h2>The voices</h2>
        <p>
          Read-aloud uses on-device neural text-to-speech — the same voices as the mobile app. After a
          one-time download they run entirely in your browser, even offline, with the sentence being
          spoken highlighted on the page.
        </p>
        <h2>Everywhere you read</h2>
        <p>
          Phone, web, and Windows, in sync. Pick up exactly where you left off, on whatever screen is
          closest.
        </p>
      </div>

      <div className="cta-row">
        <Link className="btn" to="/login">Get started</Link>
        <a className="navlink" href="https://github.com/DDmonkeytron/ScrollWind/releases" target="_blank" rel="noreferrer">
          Get the Android app →
        </a>
      </div>
    </div>
  );
}
